/* モフトレチェックレポート・利用者選択 */
import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import Popup from '../../containers/Popup';
import UserListHeader from '../../containers/UserListHeader';
import UserSelectBody from '../../containers/UserSelectBody';
import KanaList from '../../containers/KanaList';
import { MENU_TYPE } from '../../constants/Menu';
import PageLoader from '../Atoms/PageLoader';

const useStyles = makeStyles(() => ({
  table: {
    display: 'table',
    width: '100%',
    margin: '0 0 80px 0',
    overflow: 'hidden',
    borderSpacing: 0,
    borderCollapse: 'separate',
    borderRadius: '10px',
    boxShadow: '0 2px 3px 1px #ccc',
  },
}));

interface UserSelectMoffCheckProps {
  moffAPI: any;
  moffCheckCount: any;
}

const UserSelectMoffCheck: FC<UserSelectMoffCheckProps> = ({ moffAPI }) => {
  const classes = useStyles();

  return (
    <Box>
      <Popup />
      <KanaList />
      {moffAPI.Loaded ? null : <PageLoader />}

      <Box>
        <table className={classes.table}>
          <thead>
            <tr>
              <UserListHeader UserListFieldKey="KirokuModel" />
            </tr>
          </thead>
          <tbody>{moffAPI.Loaded ? <UserSelectBody type={MENU_TYPE.MoffCheck} users={moffAPI.result} /> : null}</tbody>
        </table>
      </Box>
    </Box>
  );
};

export default UserSelectMoffCheck;
